.appShell {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: var(--color-bg-base);
  color: var(--color-fg-base);
}

.mainLayout {
  display: flex;
  flex: 1;
  min-height: 0; /* Important for flex children to allow inner scrolling */
}

.centerArea {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
